import {
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  GET_ACCOUNT,
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNT_ERROR,
  RESEND_USER_INVITE,
  RESEND_USER_INVITE_SUCCESS,
  RESEND_USER_INVITE_ERROR,
  RESET_USER_INVITE_SENT_TO,
  GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_SUCCESS,
  GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS,
  GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_ERROR,
  GET_CAMPAIGN_SPENDS,
  GET_CAMPAIGN_SPENDS_SUCCESS,
  GET_CAMPAIGN_SPENDS_ERROR,
  GET_CAMPAIGNS_BY_ACCOUNT,
  GET_CAMPAIGNS_BY_ACCOUNT_SUCCESS,
  GET_CAMPAIGNS_BY_ACCOUNT_ERROR,
  GET_AD_GROUPS_BY_CAMPAIGN,
  GET_AD_GROUPS_BY_CAMPAIGN_SUCCESS,
  GET_AD_GROUPS_BY_CAMPAIGN_ERROR,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_SUCCESS,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_ERROR,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_SUCCESS,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_ERROR,
  GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS,
  GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_SUCCESS,
  GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  current_account: null,
  users: [],
  error: null,
  roles: [],
  user_invite_sent_to: null,
  admin_manage_client_account_with_brands: [],
  admin_manage_client_account_with_brands_loading: null,
  admin_manage_client_account_with_brands_error: null,
  admin_manage_client_campaigns_by_account: [],
  admin_manage_client_campaigns_by_account_loading: null,
  admin_manage_client_campaigns_by_account_error: null,
  admin_manage_client_ad_groups_by_campaign: [],
  admin_manage_client_ad_groups_by_campaign_loading: null,
  admin_manage_client_ad_groups_by_campaign_error: null,
  admin_manage_client_source_types: [],
  admin_manage_client_source_types_loading: null,
  admin_manage_client_source_types_error: null,
  admin_manage_client_source_types_by_account: [],
  admin_manage_client_source_types_by_account_loading: false,
  admin_manage_client_source_types_by_account_error: null,
  admin_manage_client_marketing_groups: [],
  admin_manage_client_marketing_groups_loading: false,
  admin_manage_client_marketing_groups_error: null,
}

const accounts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.users,
        //current_account: action.payload.account,
      }

    case GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_USER_SUCCESS:
      return {
        ...state,
        //TODO: Fix below, ideally the add user and get users should have the same atomic structure
        users: [...state.users] //, action.payload.user],
      }

    case ADD_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(user =>
          user.id.toString() === action.payload.user.id.toString()
            ? { user, ...action.payload }
            : user
        ),
      }

    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter(
          user => user.id.toString() !== action.payload.user.id.toString()
        ),
      }

    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ACCOUNT:
      return {
        ...state,
        error: null,
      }

    case GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        error: null,
        current_account: action.payload
      }

    case GET_ACCOUNT_ERROR:
      return {
        ...state,
        error: action.payload
      }

    case RESEND_USER_INVITE:
      return {
        ...state,
        error: null,
      }

    case RESEND_USER_INVITE_SUCCESS:
      return {
        ...state,
        error: null,
        invite_sent_to: action.payload
      }

    case RESEND_USER_INVITE_ERROR:
      return {
        ...state,
        error: action.payload
      }

    case RESET_USER_INVITE_SENT_TO:
      return {
        ...state,
        invite_sent_to: null,
        error: null
      }

    case GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS:
      return {
        ...state,
        admin_manage_client_account_with_brands_loading: true,
        admin_manage_client_account_with_brands_error: null,
      }

    case GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_SUCCESS:
      return {
        ...state,
        admin_manage_client_account_with_brands: action.payload,
        admin_manage_client_account_with_brands_loading: false,
        admin_manage_client_account_with_brands_error: null,
      }

    case GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_ERROR:
      return {
        ...state,
        admin_manage_client_account_with_brands_loading: false,
        admin_manage_client_account_with_brands_error: action.payload,
      }

    case GET_CAMPAIGN_SPENDS:
      return {
        ...state,
        campaign_spends_error: null,
        campaign_spends_loading: true
      }

    case GET_CAMPAIGN_SPENDS_SUCCESS:
      return {
        ...state,
        campaign_spends_loading: false,
        campaign_spends: action.payload
      }

    case GET_CAMPAIGN_SPENDS_ERROR:
      return {
        ...state,
        campaign_spends_loading: false,
        campaign_spends_error: action.payload
      }
    case GET_CAMPAIGNS_BY_ACCOUNT:
      return {
        ...state,
        admin_manage_client_campaigns_by_account_error: null,
        admin_manage_client_campaigns_by_account_loading: true
      }
    case GET_CAMPAIGNS_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        admin_manage_client_campaigns_by_account: action.payload,
        admin_manage_client_campaigns_by_account_loading: false,
        admin_manage_client_campaigns_by_account_error: null
      }
    case GET_CAMPAIGNS_BY_ACCOUNT_ERROR:
      return {
        ...state,
        admin_manage_client_campaigns_by_account_error: action.payload,
        admin_manage_client_campaigns_by_account_loading: false,
      }
    case GET_AD_GROUPS_BY_CAMPAIGN:
      return {
        ...state,
        admin_manage_client_ad_groups_by_campaign_error: null,
        admin_manage_client_ad_groups_by_campaign_loading: true
      }
    case GET_AD_GROUPS_BY_CAMPAIGN_SUCCESS:
      return {
        ...state,
        admin_manage_client_ad_groups_by_campaign: action.payload,
        admin_manage_client_ad_groups_by_campaign_error: null,
        admin_manage_client_ad_groups_by_campaign_loading: false
      }
    case GET_AD_GROUPS_BY_CAMPAIGN_ERROR:
      return {
        ...state,
        admin_manage_client_ad_groups_by_campaign_error: action.payload,
        admin_manage_client_ad_groups_by_campaign_loading: false
      }

    case GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES:
      return {
        ...state,
        admin_manage_client_source_types_loading: true,
        admin_manage_client_source_types_error: null,
      }
    case GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_SUCCESS:
      return {
        ...state,
        admin_manage_client_source_types: action.payload,
        admin_manage_client_source_types_loading: false,
        admin_manage_client_source_types_error: null,
      }
    case GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_ERROR:
      return {
        ...state,
        admin_manage_client_source_types: action.payload,
        admin_manage_client_source_types_loading: false,
      }

    case GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT:
      return {
        ...state,
        admin_manage_client_source_types_by_account_loading: true,
        admin_manage_client_source_types_by_account_error: null,
      }
    case GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        admin_manage_client_source_types_by_account: action.payload,
        admin_manage_client_source_types_by_account_loading: false,
        admin_manage_client_source_types_by_account_error: null,
      }
    case GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_ERROR:
      return {
        ...state,
        admin_manage_client_source_types_by_account_loading: false,
        admin_manage_client_source_types_by_account_error: action.error,
      }

    case GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS:
      return {
        ...state,
        admin_manage_client_marketing_groups_loading: true,
        admin_manage_client_marketing_groups_error: null,
      }
    case GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_SUCCESS:
      return {
        ...state,
        admin_manage_client_marketing_groups: action.payload,
        admin_manage_client_marketing_groups_loading: false,
        admin_manage_client_marketing_groups_error: null,
      }
    case GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_ERROR:
      return {
        ...state,
        admin_manage_client_marketing_groups_loading: false,
        admin_manage_client_marketing_groups_error: action.error,
      }

    default:
      return state
  }
}

export default accounts
